import { useState } from 'react'
import { useNavigate } from 'react-router'

import { UserSession } from '~/data/auth.server'

import Modal from '../Modal'
import MobileModal from './MobileModal'
import { City } from '~/utils'

import Menu from '~/icons/menu.svg'
import Logo from '~/icons/logo.svg'
import Dashboard from '~/icons/dashboard.svg'
import CreateEvent from '~/icons/createEvent.svg'

const Mobile = ({
  user,
  city,
  openLocationModal,
}: {
  user?: UserSession | null
  city?: City
  openLocationModal: () => void
}) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const navigate = useNavigate()

  return (
    <div className='flex md:hidden pt-4 pb-2 px-6 justify-between'>
      <Modal isNav open={modalOpen}>
        <MobileModal
          user={user}
          city={city}
          openLocationModal={openLocationModal}
          onClose={() => setModalOpen(false)}
        />
      </Modal>
      <button onClick={() => navigate('/')}>
        <img src={Logo} alt='logo_icon' />
      </button>
      <div className='flex gap-3 items-center'>
        {user && (
          <button
            className='p-2'
            onClick={() => navigate('/dashboard/user/favourites')}
          >
            <img src={Dashboard} alt='dashboard_icon' />
          </button>
        )}
        {user && (
          <button className='p-2' onClick={() => navigate('/events/create')}>
            <img src={CreateEvent} alt='create_event_icon' />
          </button>
        )}
        <button className='p-2' onClick={() => setModalOpen(true)}>
          <img src={Menu} alt='menu' />
        </button>
      </div>
    </div>
  )
}

export default Mobile
